import React from 'react';
import PropTypes from 'prop-types';
import styles from './tooltip.css';

function Tooltip({ text }) {
  return (
    <div className={styles.tooltipContainer} data-test-id="tooltip-container">
      <div className={styles.tooltipText} data-test-id="tooltip-text">
        {text}
      </div>
    </div>
  );
}

Tooltip.propTypes = {
  text: PropTypes.string,
};

export default Tooltip;
